module.exports = __webpack_public_path__ + "static/media/flutterwave-logos-white.877be0eb.png";